<style src="@/assets/scss/general.scss" lang="scss"></style>

<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { productSwitch } from './mixins/product-switch'

  export default {
    name: 'App',
    mixins: [productSwitch],
    methods: {
      ...mapActions(['setProductId'])
    },
    mounted() {
      this.setProductId(productSwitch.SSP_PORTAL)
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue